import {GeolocationDto} from "../../../models/misc/position/geolocation-dto";
import {circle} from "leaflet";


export class LocationProcessor {
  static processLocation(deviceId: string, geolocationDto: GeolocationDto[], markers: any[], isFarFromCenter: {
    [key: string]: boolean
  }): { lat: number, lng: number, count: number }[] {
    if (geolocationDto.length == 0) return [];
    let bundles = [];
    let firstBundle = LocationProcessor.createBundle();
    firstBundle.lat = geolocationDto[0].latitude;
    firstBundle.lng = geolocationDto[0].longitude;
    firstBundle.count = 1;
    // in Meters
    let radius = 150;

    for (let i = 1; i < geolocationDto.length; i++) {
      let currentLocation = geolocationDto[i];
      let found = false;
      for (let j = 0; j < bundles.length; j++) {
        let bundle = bundles[j];
        if (LocationProcessor.haversineDistance(bundle.lat, bundle.lng, currentLocation.latitude, currentLocation.longitude) < radius) {
          bundle.lat = (bundle.lat * bundle.count + currentLocation.latitude) / (bundle.count + 1);
          bundle.lng = (bundle.lng * bundle.count + currentLocation.longitude) / (bundle.count + 1);
          bundle.count++;
          found = true;
          break;
        }
      }
      if (!found) {
        let newBundle = LocationProcessor.createBundle();
        newBundle.lat = currentLocation.latitude;
        newBundle.lng = currentLocation.longitude;
        newBundle.count = 1;
        bundles.push(newBundle);
      }
    }

    let hasMoreThanOne = false;
    let signalCount = 20
    isFarFromCenter[deviceId] = false;
    for (let bundle of bundles) {
      if (hasMoreThanOne && bundle.count >= signalCount) {
        isFarFromCenter[deviceId] = true;
      }
      if (bundle.count >= signalCount) {
        hasMoreThanOne = true;
        break;
      }
    }

    for (let bundle of bundles) {

      markers.push(
        circle([bundle.lat, bundle.lng], {
          radius: 150,
          color: 'red',
          fillColor: '#f03',
          fillOpacity: 0.25
        }));
    }

    return bundles
  }


  static createBundle() {
    return {
      lat: 0,
      lng: 0,
      count: 0
    }
  }

  public static haversineDistance(lat1: number, lon1: number, lat2: number, lon2: number) {
    var R = 6371; // Radius of the earth in km
    var dLat = LocationProcessor.deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = LocationProcessor.deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(LocationProcessor.deg2rad(lat1)) * Math.cos(LocationProcessor.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  }

  public static deg2rad(deg: number) {
    return deg * (Math.PI / 180)
  }
}
